var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"white--text",attrs:{"left":_vm.side ==='left',"right":_vm.side === 'right',"size":_vm.size,"color":_vm.color},domProps:{"innerHTML":_vm._s(_vm.getAvatar)}})
}
var staticRenderFns = []

export { render, staticRenderFns }